import script from "./Categories.vue?vue&type=script&setup=true&lang=js"
export * from "./Categories.vue?vue&type=script&setup=true&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=2878d58b&scoped=true&lang=css"

import exportComponent from "/var/www/coursat-mtn-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2878d58b"]])

export default __exports__